import React, { useState } from "react";
import RichTextEditor from "react-rte";

const toolbarConfig = {
  display: [
    "INLINE_STYLE_BUTTONS",
    "BLOCK_TYPE_BUTTONS",
    "BLOCK_ALIGNMENT_BUTTONS",
    "BLOCK_TYPE_DROPDOWN",
    "HISTORY_BUTTONS",
    "LINK_BUTTONS",
  ],
  INLINE_STYLE_BUTTONS: [
    { label: "Bold", style: "BOLD", className: "custom-css-class" },
    { label: "Italic", style: "ITALIC" },
    { label: "Underline", style: "UNDERLINE" },
    { label: "Monospace", style: "CODE" },
    { label: "Strikethrough", style: "STRIKETHROUGH" },
  ],
  BLOCK_TYPE_DROPDOWN: [
    { label: "Normal", style: "unstyled" },
    { label: "Heading Large", style: "header-one" },
    { label: "Heading Medium", style: "header-two" },
    { label: "Heading Small", style: "header-three" },
    { label: "Inline Title", style: "header-three" },
    { label: "Block Title", style: "header-four" },
    { label: "Block Subtitle", style: "header-five" },
    { label: "Block Quote", style: "blockquote" },
    { label: "Code Block", style: "code-block" },
  ],
  BLOCK_TYPE_BUTTONS: [
    { label: "UL", style: "unordered-list-item" },
    { label: "OL", style: "ordered-list-item" },
    { label: "Blockquote", style: "blockquote" },
  ],
  BLOCK_ALIGNMENT_BUTTONS: [
    { label: "Align Left", style: "ALIGN_LEFT" },
    { label: "Align Center", style: "ALIGN_CENTER" },
    { label: "Align Right", style: "ALIGN_RIGHT" },
    { label: "Align Justify", style: "ALIGN_JUSTIFY" },
  ],
};

const TextEditor = ({ id, placeholder, edit, prefill, onChangeTextEditor }) => {
  const [value, setValue] = useState(
    RichTextEditor.createValueFromString(prefill, "html")
  );

  const onChangeHandler = (val) => {
    setValue(val);
    if (onChangeTextEditor) {
      onChangeTextEditor(val.toString("html"), id);
    }
  };

  return (
    <RichTextEditor
      toolbarClassName="demo-toolbar"
      editorClassName="demo-editor"
      placeholder={placeholder}
      readOnly={!edit}
      value={value}
      onChange={onChangeHandler}
      toolbarConfig={toolbarConfig}
    />
  );
};

export default TextEditor;
